<template>

    <transition-group class="tips-container" name="tips-slide">

        <template v-for="(tip, index) in tips">

            <div v-if="tipsIndex === index" v-bind:key="index" class="tips">

                <div class="tips-left">

                    <img :src="`/img/tips/twemoji-tips-${ tipsIndex + 1 }.svg`" class="tips-icon">

                </div>

                <div class="tips-right">

                    <p class="tips-title">{{ $t('global_did_you_know_title') }}</p>

                    <markdown :text="tip" class="tips-subtitle"></markdown>

                </div>

            </div>

        </template>

    </transition-group>

</template>

<script>

import Markdown from '@/components/Markdown'

export default {

    name: 'tips-fetch',

    components: {Markdown},

    data() {
        return {
            tipsIndex: 0,
            tips: []
        }
    },

    mounted() {

        this.tipsDance()

        this.getTips()

    },

    methods: {

        tipsDance() {

            const self = this

            setInterval(function () {

                self.tipsIndex = self.tipsIndex >= self.tips.length - 1 ? 0 : self.tipsIndex + 1

            }, 8000)

        },

        getTips() {

            let index = 1
            let bool = true

            while (bool) {

                if (this.$te(`fetch_tips_${index}`)) {

                    this.tips.push(this.$t(`fetch_tips_${index}`))

                } else {
                    bool = false
                }

                index++

            }

        }

    }

}

</script>

<style lang="scss" scoped>


.tips-container {
    position: relative;
    min-height: 52px;
    width: 100%;
}

.tips {
    position: absolute;
    height: 86px;
    width: 100%;
    padding: 16px 16px 16px 0;
    display: flex;
    flex-direction: row;
    border-radius: 12px;
    box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.05);
    background-color: $white;
}

.tips-left {
    min-width: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tips-icon {
    width: 24px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        width: 32px;
    }
}

.tips-right {
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: center;
}

.tips-title {
    height: 18px;
    font-size: 13px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: $aquamarine;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 17px;
        line-height: 1.41;
    }
}

.tips-subtitle {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: $moon;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 15px;
        line-height: 1.33;
    }
}


.tips-slide-enter-active {
    animation: anim-slide-in 1s cubic-bezier(.5, 0, .25, 1);
    @media screen and (min-width: $above-tablet-length) {
        animation: anim-desktop-slide-in .6s ease-in-out .4s;
        opacity: 0;
    }
}

@keyframes anim-slide-in {
    0% {
        transform: translateX(500px)
    }

    100% {
        transform: translateX(0)
    }
}

@keyframes anim-desktop-slide-in {
    0% {
        transform: translateY(48px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.tips-slide-leave-active {
    animation: anim-slide-out 1s cubic-bezier(.5, 0, .25, 1);
    @media screen and (min-width: $above-tablet-length) {
        animation: anim-desktop-slide-out .6s ease-in;
    }
}

@keyframes anim-slide-out {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(-500px)
    }
}

@keyframes anim-desktop-slide-out {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-96px);
        opacity: 0;
    }
}

</style>
